<div class="screenshot-tooltip" [ngClass]="sizeClass | async">
  <q9-preview-image [src]="src" [altSrc]="altSrc" (err)="onError($event)"></q9-preview-image>
</div>
